<template>
  <div
    v-if="isShow || isInlinePin"
    :class="isHidden ? 'is_hidden' : ''"
  >
    <div v-if="isInline || isInlinePin">
      <slot name="dialog-content"></slot>
    </div>
    <div
      v-else
      class="overlay-panel"
      :class="{
        'overlay-panel-right': showInRight,
        'overlay-panel-left': showInLeft,

      }"
      :style="{ zIndex: baseZIndex }"
      :data-index="baseZIndex"
      :data-uid="_uid"
    >
      <div
        :id="dialogId"
        class="dialog-container"
        :style="{
          top: dialogContentTop,
          width: width + 'vw !important',
          left:  left + 'vw !important',
        }"
        @scroll="handleScrollDialog($event)"
      >
        <slot name="sticky-bar"></slot>
        <div
          class="dialog-content-container"
          :style="
            isEmbed && iframeParentHeight
              ? `max-height: ${maxHeightDialogContent}px;`
              : ''
          "
          @scroll="handleScrollDialog($event)"
          ref="dialogContent"
        >
          <slot name="dialog-content"></slot>
        </div>
        <div
          v-if="!hideCloseBtn"
          class="close-button-container"
          :class="{ 'btn-bg-white': useWhiteBgCloseButton }"
          :style="{
            zIndex: baseZIndex,
            top: topCloseBtn,
            right: rightCloseBtn,
          }"
        >
          <i
            class="material-icons close-button-tour-handle"
            @click="handleCloseDialog()"
          > cancel </i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/*
This component is used to show a modal dialog
By using <modal> of vue-js-modal, it always show the dialog at center of screen
However, in some case, we want to show the dialog at a specific position (not center)
*/
import { mapGetters } from "vuex";

export default {
  name: "ModalDialog",
  props: {
    // True if dialog is showed
    value: Boolean,
    width: {
      type: Number,
      default: 80,
    },
    closeByClickOutside: {
      type: Boolean,
      default: false,
    },
    // Specify layer in case of multiple dialog in screen. Dialog which higher level will be display at top
    level: {
      type: Number,
      default: 2,
    },
    blockBackgroundScroll: {
      type: Boolean,
      default: true,
    },
    hideCloseBtn: Boolean,
    useWhiteBgCloseButton: {
      type: Boolean,
      default: false,
    },
    loadTimeout: {
      type: Number,
      default: 510,
    },
    isInline: {
      type: Boolean,
      default: false,
    },
    isInlinePin: {
      type: Boolean,
      default: false,
    },
    showInRight: Boolean, // Show in right side of screen
    showInLeft: Boolean, // Show half side of the left
    isHidden: Boolean,
    topCloseBtn: {
      type: String,
      default: "1em",
    },
    rightCloseBtn: {
      type: String,
      default: "1em",
    },
  },
  data() {
    return {
      topPosition: null,
      closeBtnTop: 0,
      isShow: false,
      baseZIndex: 9980 + 10 * this.level,
    };
  },
  computed: {
    ...mapGetters([
      "iframePositionTop",
      "iframeParentHeight",
      "iframeScaleY",
      "agencyID",
      "isAgent",
    ]),
    maxHeightDialogContent() {
      if (this.agencyID && [24].includes(Number(this.agencyID))) {
        return this.iframeParentHeight - 200;
      } else {
        return this.iframeParentHeight - 100;
      }
    },
    dialogContentTop() {
      if (this.topPosition == null) {
        return "unset";
      }
      return this.topPosition + "px";
    },
    dialogId() {
      return `enginehire-dialog-container-${this._uid}`;
    },
    /* Check if the app is displayed inside an iframe or embed tag
    https://stackoverflow.com/questions/326069/how-to-identify-if-a-webpage-is-being-loaded-inside-an-iframe-or-directly-into-t
    */
    isEmbed() {
      if (this.isAgent) {
        return false;
      }
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    },
    left() {
      if (this.showInLeft) {
        return 0;
      }
      if (this.showInRight) {
        return 100 - this.width;
      }
      return (100 - this.width) / 2;
    },
  },
  watch: {
    value: {
      handler(val) {
        this.$store.dispatch("setDialogScrollTop", 0);
        if (val && !this.isInlinePin) {
          this.isShow = true;
          // Find z-index of all existing modal dialog
          const listDialogElements =
            document.getElementsByClassName("overlay-panel");
          let maxZIndex = 0;
          for (const element of listDialogElements) {
            // Skip current element
            if (element.getAttribute("data-uid") === this._uid) {
              continue;
            }
            let zIndex = element.getAttribute("data-index");
            if (zIndex && zIndex > maxZIndex) {
              zIndex = Number(zIndex);
              if (zIndex > maxZIndex) {
                maxZIndex = zIndex;
              }
            }
          }
          if (this.baseZIndex <= maxZIndex) {
            this.baseZIndex = maxZIndex + 1;
          }

          setTimeout(() => {
            // Dialog is open
            // Add class v--modal-block-scroll to the body
            if (this.blockBackgroundScroll) {
              document.body.classList.add("v--modal-block-scroll");
            }
            const boundingRect = this.$refs.dialogContent.getBoundingClientRect();
            console.log(boundingRect, window.innerHeight);
            this.closeBtnTop = boundingRect.top - 18;
            const dialogHeight = boundingRect.height;
            if (this.isEmbed) {
              let top;
              if (this.iframePositionTop) {
                top = 0 - this.iframePositionTop;
                if (this.iframeScaleY) {
                  top = top / this.iframeScaleY;
                }
              } else {
                top = this.$store.getters.lastClickY - dialogHeight + 30;
              }
              if (top < 0) {
                top = 0;
              }
              if (top < 100) {
                if (
                  this.iframeParentHeight &&
                  dialogHeight < this.iframeParentHeight - 100
                ) {
                  top = 100;
                }
              }
              this.topPosition = top;
            } else {
              this.topPosition = (window.innerHeight - dialogHeight) / 2;
              console.log(this.topPosition);
              if (this.width >= 90) {
                if (this.topPosition > window.innerHeight * 0.1) {
                  this.topPosition = window.innerHeight * 0.05;
                }
              }
            }
            setTimeout(() => {
              this.closeBtnTop =
                this.$refs.dialogContent.getBoundingClientRect().top - 18;
            }, 10);
          }, this.loadTimeout);
        } else {
          if (this.$refs.modal && this.$refs.modal.classList) {
            this.$refs.modal.classList.add("closing-dialog");
          }
          this.isShow = false;
          // Remove class v--modal-block-scroll to the body
          if (this.blockBackgroundScroll) {
            document.body.classList.remove("v--modal-block-scroll");
            document.body.style.paddingRight = null;
          }
        }
      },
      immediate: true,
    },
    level: {
      handler(val) {
        this.baseZIndex = 9980 + 10 * this.level;
      },
      immediate: true,
    },
  },
  methods: {
    handleScrollDialog(event) {
      this.$store.dispatch("setDialogScrollTop", event.target.scrollTop);
    },
    handleCloseDialog() {
      this.$emit("close");
      this.$emit("input", false);
    },
  },
};
</script>
<style scoped>
.overlay-panel {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.2);
  opacity: 1;
}

.dialog-container {
  position: fixed;
  z-index: 1;
  background: white;
  animation: anime 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  border-radius: 4px;
  /* height: fit-content; */
  max-height: 90vh;
}

.in-embed .dialog-container {
  animation: unset;
}

.closing-dialog {
  animation: anime-close 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.dialog-content-container {
  overflow: auto;
  max-height: 90vh;
  background-color: white;
}

.close-button-container {
  z-index: 2;
  position: absolute;
}

.close-button-container > i {
  font-size: 36px;
  cursor: pointer;
  color: var(--coredarkcolor);
}
.btn-bg-white {
  background-color: white;
  height: 36px;
  border-radius: 50px;
}

@media (max-width: 768px) {
  .dialog-container {
    width: calc(100vw - 1em) !important;
    left: 0.5em !important;
  }

  .close-button-container {
    right: 0 !important;
  }
}

@media (min-width: 769px) {
  .overlay-panel-right > .dialog-container.closing-dialog {
    animation: anime-right-close 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  }

  .overlay-panel-right {
    position: relative;
    height: 0;
  }

  .overlay-panel-right > .dialog-container {
    top: 0 !important;
    height: 100vh !important;
    left: 15vw !important;
    width: calc(85vw - 16px) !important;
    box-shadow: -2px 0 8px #00000026;
    animation: anime-right-open 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  }

  .overlay-panel-right > .dialog-container > .dialog-content-container {
    max-height: 100vh;
  }

  .overlay-panel-left {
    position: relative;
    height: 0;
  }

  .overlay-panel-left > .dialog-container {
    left: 0 !important;
    width: calc(50vw - 16px) !important;
    box-shadow: -2px 0 8px #00000026;
  }

  .overlay-panel-left > .dialog-container > .dialog-content-container {
    max-height: 100vh;
  }
}

@keyframes anime {
  0% {
    width: 60px;
    height: 60px;
    left: 50%;
    top: 50%;
    background: #f8f8f8;
    box-shadow: 10px 10px 10px #cccccc, 10px 10px 10px #ffffff,
      0 0 0 #cccccc inset, 0 0 0 #ffffff inset;
    overflow: hidden;
  }
  100% {
    background: #fafafa;
    box-shadow: 40px 40px 40px #cccccc, 0 0 0 #ffffff, 0 0 0 #cccccc inset,
      2px 2px 2px #ffffff inset;
  }
}

@keyframes anime-close {
  0% {
    background: #fafafa;
    box-shadow: 40px 40px 40px #cccccc, 0 0 0 #ffffff, 0 0 0 #cccccc inset,
      2px 2px 2px #ffffff inset;
    overflow: hidden;
  }
  40% {
    height: 60px;
    top: 50%;
    background: #f8f8f8;
    box-shadow: 10px 10px 10px #cccccc, 10px 10px 10px #ffffff,
      0 0 0 #cccccc inset, 0 0 0 #ffffff inset;
    overflow: hidden;
  }
  100% {
    width: 60px;
    height: 60px;
    left: 50%;
    top: 50%;
    background: #f8f8f8;
    box-shadow: 10px 10px 10px #cccccc, 10px 10px 10px #ffffff,
      0 0 0 #cccccc inset, 0 0 0 #ffffff inset;
    overflow: hidden;
  }
}

@keyframes anime-right-close {
  0% {
    margin-left: 0px;
    overflow: hidden;
  }
  100% {
    margin-left: 85vw;
    overflow: hidden;
  }
}

@keyframes anime-right-open {
  0% {
    margin-left: 85vw;
    overflow: hidden;
  }
  100% {
    margin-left: 0;
    overflow: hidden;
  }
}

.is_hidden {
  visibility: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/common/global-dialogs/ModalDialog.vue